module.exports = __webpack_public_path__ + "static/media/wmTrial-words-2.20da8465.mp3";